import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { getApiBaseUrl } from "@config/shared/api-paths";
import { REALTIME_HUB_PATH } from "@config/shared/realtime-events";

// SignalR calls this before every negotiate, so each (re)connect carries the current token
// (AuthContext and the auth interceptor keep it refreshed). Throwing instead of returning
// nothing keeps the client from ever opening an anonymous connection: the attempt fails and
// is retried once a token exists.
export const readAccessToken = () => {
  const token = sessionStorage.getItem("accessToken");
  if (!token) throw new Error("No access token: not connecting the live channel anonymously");
  return token;
};

export const createHub = ({
  url = `${getApiBaseUrl()}${REALTIME_HUB_PATH}`,
  httpOptions = {},
  logLevel = LogLevel.Warning,
} = {}) =>
  new HubConnectionBuilder()
    .withUrl(url, { accessTokenFactory: readAccessToken, ...httpOptions })
    // No .withAutomaticReconnect(): realtimeConnection retries every case itself (a failed
    // first start, a dropped line, a server close), so there is one retry path, not two.
    .configureLogging(logLevel)
    .build();
